<template>
  <div>
    <v-card>
      <v-card-title>
        Lista de estudiantes
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="students_rate"
        :search="search"
        :loading="loading"
        hide-actions
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.full_name }}</td>
          <td class="text-xs-center">{{ props.item.gender }}</td>
          <td class="text-xs-center">{{ props.item.grade_level }}</td>
          <td class="text-xs-center">
            <v-select
              :items="rateItems"
              v-model="rate[props.item.student_id]"
              label="Calificación"
              @change="rateStudent(props.item.id, $event)"
            ></v-select>
          </td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'course-student-rate-view',
    props: {
      date_id: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        headers: [
          { text: this.$t('extracurriculares.teachers_assistance.assistance.table.stuent'), align: 'center', value: 'full_name' },
          { text: this.$t('extracurriculares.teachers_assistance.assistance.table.gender'), align: 'center', value: 'gender' },
          { text: this.$t('extracurriculares.teachers_assistance.assistance.table.gade'), align: 'center', value: 'grade_level' },
        ],
        students_rate: [],
        search: '',
        loading: false,
        rate: {},
        rateItems: [
          { value: 'APPROVED', text: 'APROBADO' },
          { value: 'REAPPROVED', text: 'REPROBADO' },
          { value: 'ENROLLED', text: 'PENDIENTE' },
        ]
      }
    },
    watch: {
      date_id(newValue, oldValue) {
        if (newValue != 0) {
          this.getStudents()
        }
      }
    },
    methods: {
      getStudents() {
        console.log(this.$props.date_id)

        axios.get('/api/extracurriculares/teacher/students/rate/' + this.$props.date_id)
        .then(resp => {
          if (resp.status === 200) {
            this.students_rate = resp.data.students
            resp.data.students.forEach(student => {
              this.rate[student.student_id] = student.student_status
            });
          }
        })
        .catch(err => console.log(err))
      },
      rateStudent(id, value) {
        const data = { id, value }

        axios.post('/api/extracurriculares/teacher/students/rate', data)
          .then(resp => {
            if (resp.status === 200) {

            }
          })
          .catch(error => console.log(error));
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/teacher/rate.vue